import React from "react";

const HeadingPri = (props) => {
  return <h6 className="Schedule__TimeSlot-heading fs-14 mt-4 mb-3 tw:font-bold">{props.text}</h6>;
};

export default HeadingPri;
